<template>
  <div id="page">
        <div class="banner-wrap">
          <section class="banners">
            <div class="title-wrap">
              <h4>加入大吕 娱乐未来</h4>
              <p>一起与我们展望未来，创造无限可能</p>
            </div>
            <div class="ren-wrap">
              <img src="../assets/img/about/ren.gif" alt="">
            </div>
            <!-- <img :src="'storage/'+bannerUrl" alt="加入我们" /> -->
          </section>
        </div>
        <div class="container">

          <!-- 薪水与福利 -->
            <section class="Compensation">
              <h4>薪酬与福利</h4>
              <p>Compensation and benefits</p>
              <div class="content-wrap">
                <div class="item">
                  <div class="img-wrap" :class="activeIndex == 1 ? 'on' : '' " @mouseover="activeIndex = 1">
                    <img src="../assets/img/join/icon_ydr.png" alt="">
                  </div>
                  <h6>运动日</h6>
                  <p>工作娱乐一手抓</p>
                  <p>要想身体好</p>
                  <p>文体活动少不了</p>
                </div>
                <div class="item">
                  <div class="img-wrap" :class="activeIndex == 1 ? 'on' : '' " @mouseover="activeIndex = 1">
                    <img src="../assets/img/join/icon_wx.png" alt="">
                  </div>
                  <h6>五险双休</h6>
                  <p>为了你的前途</p>
                  <p>我们也会努力争先 </p>
                  <p>让你无后顾之忧</p>
                </div>
                <div class="item">
                  <div class="img-wrap" :class="activeIndex == 1 ? 'on' : '' " @mouseover="activeIndex = 1">
                    <img src="../assets/img/join/icon_jr.png" alt="">
                  </div>
                  <h6>节日福利</h6>
                  <p>元旦、圣诞</p>
                  <p> 一年中每一个节日</p>
                  <p>我们都用”新”准备</p>
                </div>
                <div class="item">
                  <div class="img-wrap" :class="activeIndex == 1 ? 'on' : '' " @mouseover="activeIndex = 1">
                    <img src="../assets/img/join/icon_tj.png" alt="">
                  </div>
                  <h6>团建活动</h6>
                  <p>进了门</p>
                  <p> 我们就是一家人</p>
                  <p>一同团建去旅行</p>
                </div>
                <div class="item">
                  <div class="img-wrap" :class="activeIndex == 1 ? 'on' : '' " @mouseover="activeIndex = 1">
                    <img src="../assets/img/join/icon_ss.png" alt="">
                  </div>
                  <h6>员工宿舍</h6>
                  <p>仓廪实而知礼节</p>
                  <p>安顿好床</p>
                  <p>才会有更大的梦</p>
                </div>
              </div>

            </section>


        </div>

        <div class="live-wrap">
          <section class="live">
            <div class="wrap">
              <div class="ren-wrap">
                <img src="../assets/img/about/ren.gif" alt="">
              </div>
              <div class="top-icon">
                <img src="../assets/img/join/icon_star.png" alt="">
              </div>
                <div class="join-swiper1 swiper-container swiper-no-swiping">
                  <div class="swiper1-body swiper-wrapper">
                    <div class="swiper-slide carousel-box">
                      <div>
                        <img src="../assets/img/join/join_1.jpg" draggable="false" />
                      </div>
                    </div>
                    <div class="swiper-slide carousel-box">
                      <div>
                        <img src="../assets/img/join/join_5.jpg" draggable="false" />
                      </div>
                    </div>
                    <div class="swiper-slide carousel-box">
                      <div>
                        <img src="../assets/img/join/join_2.jpg" draggable="false" />
                      </div>
                    </div>
                    <div class="swiper-slide carousel-box">
                      <div>
                        <img src="../assets/img/join/join_3.jpg" draggable="false" />
                      </div>
                    </div>
                    <div class="swiper-slide carousel-box">
                      <div>
                        <img src="../assets/img/join/join_4.jpg" draggable="false" />
                      </div>
                    </div>
                  </div>
                </div>

            </div>

          </section>
        </div>
  </div>
</template>

<script>
export default {
  name:"join",
  data(){
    return{
      nature: "",
      // 当前选中项索引
      active: 0,
      join: null,
      jobContent:null,
      showTop: false,
      pages:"8",
      tabIndex:1,
      bannerUrl:null,
      activeIndex:1
    }
  },
  mounted(){
      var swiper = new Swiper('.join-swiper1', {
        autoplay:3000,
        autoplayDisableOnInteraction : false,
        spaceBetween: 0,
        observer:true,  //修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,


      });
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
.container,.live-wrap {
  p,span,a{
    font-size: px2rem(14);
  }
  h4{
    font-family: helvetica;
    font-size: px2rem(28);
    color: #fff;
    font-weight: 700;
    line-height: 1em;
    font-size: px2rem(28);
  }
  section {
    > h4 {
      text-align: center;
    }
    > p {
      letter-spacing: 1px;
      font-family: arial, helvetica, sans-serif;
      line-height: 2em;
      color: #fff;
      text-align: center;
    }
  }
}
.banners {
  position: relative;
  width: 100%;
  height: 200px;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .ren-wrap{
    position: absolute;
    top: 100px;
    right: 20%;
    width: 14%;
  }

}
#page{
  background: url(../assets/img/join/bg.png);
  background-size: 100% 100%;
}
.title-wrap{
  position: absolute;
  left: 12%;
  top: 20%;
  h4{
    font-size: 1.6rem;
    margin-bottom: 20px;
    color: #fff;
    letter-spacing: 2px;

  }
  p{
    font-size: 1rem;
    color: #999;
    letter-spacing: 2px;

  }
}

.live-wrap{

  padding: 36px 0;
  position: relative;
  section{
    background: url("../assets/img/join/bg_w.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  .live{
    margin: 0 1rem;
    .wrap{
      padding-top: 28px;
      position: relative;
      .top-icon{
        position: absolute;
        top: -49px;
        left: 116px;
        img{
          width: 50%;
          margin: 0 auto;
        }
      }
    }
    >h4{
      margin-bottom: 20px !important;
    }
    .ren-wrap{
      position: absolute;
      top: -30px;
      right: 20px;
      width: 14%;
    }
  }
}
.join-swiper1{
  width: 95%;
  margin: 0 auto;

}
.Compensation{
  padding-bottom: 60px;
  >p{
    margin-bottom: .5rem;
  }
    .content-wrap{
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      .item{
        margin-right: 3%;
        display: flex;
        flex-direction: column;
        width: 30%;
        background: url("../assets/img/join/join_yx.png");
        background-repeat: no-repeat;
        background-size: 100% 100%;
        margin-bottom: 1rem;
        padding: .5rem 0;
        .img-wrap{
          margin: .5rem auto 0;
        }
        img{
          width: 2rem;
          height: 2rem;
          margin: 0 auto;
        }
        h6{
          color: #fff;
          text-align: center;
          margin-bottom: .5rem;
          font-size: 1rem;
        }
        p{
          color: #999;

          text-align: center;
          line-height: px2rem(30);
          text-align: center;
          // color: #535353;
        }
      }
    }
    .content-wrap2{
      >.top-img{
        display: flex;
        justify-content: center;
        >img{
          width: 20px;
          height: 20px;
        }
        >p{
          width: 50%;
          text-align: center;
          font-size: px2rem(16);
        }
      }
    }

}




</style>



// WEBPACK FOOTER //
// src/page/join.vue